"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextField = exports.RecordsCountListSubheader = exports.RenderInputWrapper = exports.StyledPopper = exports.RecordsCountContainer = exports.DividerContainer = exports.ActionContainer = exports.ListBoxWrapper = exports.AutocompleteWrapper = void 0;
var styles_1 = require("@mui/material/styles");
var material_1 = require("@mui/material");
var colors_1 = require("../ThemeProvider/colors");
var TextField_1 = __importDefault(require("../TextField"));
var Grid_1 = __importDefault(require("../Grid"));
exports.AutocompleteWrapper = (0, styles_1.styled)(Grid_1.default)(function () { return ({
    maxWidth: '100%',
}); });
exports.ListBoxWrapper = (0, styles_1.styled)(Grid_1.default)(function () { return ({
    maxHeight: '600px',
    overflowY: 'auto',
    padding: '8px',
    boxSizing: 'border-box',
}); });
exports.ActionContainer = (0, styles_1.styled)(Grid_1.default)(function () { return ({
    height: 48,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'sticky',
    padding: '0 4px',
}); });
exports.DividerContainer = (0, styles_1.styled)(Grid_1.default)(function () { return ({
    borderTop: "1px solid ".concat(colors_1.tannerGray[300]),
}); });
exports.RecordsCountContainer = (0, styles_1.styled)('div')(function () { return ({
    height: 42,
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    padding: 0,
}); });
exports.StyledPopper = (0, styles_1.styled)(material_1.Popper)({
    '& .MuiAutocomplete-paper': {
        overflow: 'hidden',
    },
    '& .MuiAutocomplete-listbox .MuiListSubheader-root': {
        padding: 0,
        maxHeight: 48,
    },
    '& .MuiAutocomplete-listbox .MuiMenuItem-root': {
        padding: 0,
        paddingLeft: 7,
        border: 'none',
        backgroundColor: 'light',
        height: '32px',
    },
    '& .MuiAutocomplete-listbox .MuiMenuItem-root .MuiButtonBase-root': {
        marginRight: '0 !important',
    },
    '& .MuiPaper-root .MuiAutocomplete-listbox': {
        padding: 0,
        '& ul': {
            padding: 0,
            margin: 0,
        },
    },
    "& .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected='true']": {
        backgroundColor: '#fff',
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
        '& .Mui-focused': {
            backgroundColor: '#fff',
        },
    },
    '& .MuiAutocomplete-listbox .MuiAutocomplete-option[aria-selected="true"].Mui-focused': {
        backgroundColor: '#fff',
    },
    ".MuiAutocomplete-option[aria-selected='true'].Mui-focused": {
        '&:hover': {
            backgroundColor: 'rgba(0, 0, 0, 0.04)',
        },
    },
    '& .MuiPaper-root .MuiAutocomplete-listbox > li': {
        borderBottom: 'none',
        '&:last-child': {
            paddingTop: 0,
            marginBottom: '8px',
        },
    },
    '& .MuiPaper-root .recordsCountListSubheader': {
        maxHeight: 42,
    },
});
exports.RenderInputWrapper = (0, styles_1.styled)(Grid_1.default)({
    maxHeight: 126,
    overflow: 'auto',
    marginTop: 8,
    marginBottom: 2,
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    '& .MuiButtonBase-root': {
        maxWidth: '100%',
    },
    '& .MuiChip-root.MuiChip-root': {
        marginTop: '2px',
    },
});
exports.RecordsCountListSubheader = (0, styles_1.styled)(material_1.ListSubheader)(function (_a) {
    var theme = _a.theme;
    return ({
        '.MuiAutocomplete-popper &': {
            minHeight: '42px',
        },
    });
});
exports.StyledTextField = (0, styles_1.styled)(TextField_1.default)({
    '& .MuiInputBase-root .MuiInputBase-input': {
        padding: '7px 0 4px 8px',
        marginTop: '2px',
        minWidth: '50px',
    },
});
//# sourceMappingURL=styles.js.map